import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { Modal, Button, Form, Container, TextArea, Dimmer, Loader, Message, Icon, Dropdown, Input } from 'semantic-ui-react';
import LanguageEditor from 'widgets/bussiness/language-editor';
import {
  ChangeFeedbackQuestionBankStore,
  ChangeFeedbackQuestionBankDto,
  FeedbackQuestionBankDto,
  ChangeFeedbackQuestionDto,
  FeedbackQuestionDto
} from 'stores/assessments/questionBank/feedback-questionBank-store';
import { LanguagesStore } from 'stores/configuration/locations/languages-store';
import { nameof } from 'utils/object';
import i18n from 'i18n';

interface ChangeFeedbackQuestionBankModalViewProps extends WithTranslation {
  onClose: (isSuccess: boolean) => void;
  changeQuestionBank?: ChangeFeedbackQuestionBankStore;
  languagesStore?: LanguagesStore;
  currentData: FeedbackQuestionBankDto;
}

interface ChangeFeedbackQuestionBankModalViewState {
  userClickedSave: boolean;
  questionTranslations: ChangeFeedbackQuestionDto[];
}

@connect(['changeQuestionBank', ChangeFeedbackQuestionBankStore], ['languagesStore', LanguagesStore])
class NewFeedbackQuestionBankModalView extends React.Component<
  ChangeFeedbackQuestionBankModalViewProps,
  ChangeFeedbackQuestionBankModalViewState
> {
  private get changeQuestionBankStore() {
    return this.props.changeQuestionBank;
  }

  constructor(props: ChangeFeedbackQuestionBankModalViewProps) {
    super(props);

    this.state = {
      userClickedSave: false,
      questionTranslations: this.props.currentData.questionTranslations
        ? this.mapToCreateQuestionDto(this.props.currentData.questionTranslations)
        : []
    };
    this.changeQuestionBankStore.state.result = null;

    this.changeQuestionBankStore.change({
      id: this.props.currentData.id,
      question: {
        text: this.props.currentData.question.text,
        languageId: this.props.currentData.question.language.id,
        subtitle: this.props.currentData.question.subtitle
      },
      answerType: this.props.currentData.answerType,
      isMandatory: this.props.currentData.isMandatory,
      questionTranslations: this.props.currentData.questionTranslations
        ? this.mapToCreateQuestionDto(this.props.currentData.questionTranslations)
        : []
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps: ChangeFeedbackQuestionBankModalViewProps) {
    if (this.changeQuestionBankStore.state.result && this.changeQuestionBankStore.state.result.isSuccess) {
      nextProps.onClose(true);
    }
  }

  @autobind
  private handleValue(property: string, value: any) {
    this.setState({ userClickedSave: false });
    const change = {};
    change[property] = value;
    this.changeQuestionBankStore.change({ ...this.changeQuestionBankStore.state.item, ...change });
  }

  private mapToCreateQuestionDto(items: FeedbackQuestionDto[]): ChangeFeedbackQuestionDto[] {
    let data: ChangeFeedbackQuestionDto[] = [];
    items.forEach(i => {
      data.push({ text: i.text, subtitle: i.subtitle, languageId: i.language.id });
    });
    return data;
  }

  private onChangeQuestion(questionText: string) {
    let question = this.changeQuestionBankStore.state.item.question;
    if (question) {
      question.text = questionText;
    } else {
      question = {
        text: questionText,
        subtitle: '',
        languageId: this.props.currentData.question.language.id
      };
    }
    this.handleValue(nameof<ChangeFeedbackQuestionBankDto>('question'), question);
  }

  private onChangeSubtitle(questionSubtitle: string) {
    let question = this.changeQuestionBankStore.state.item.question;
    if (question) {
      question.subtitle = questionSubtitle;
    } else {
      question = {
        text: '',
        subtitle: questionSubtitle,
        languageId: this.props.currentData.question.language.id
      };
    }
    this.handleValue(nameof<ChangeFeedbackQuestionBankDto>('question'), question);
  }

  @autobind
  private onChangeItem() {
    this.setState({ userClickedSave: true });
    this.changeQuestionBankStore.update();
  }

  @autobind
  private onCancelNewItem() {
    this.changeQuestionBankStore.clear();
    this.props.onClose(false);
  }

  addQuestionsTranslation = () => {
    let question = this.state.questionTranslations;
    question.push({ text: '', subtitle: '', languageId: null });

    this.setState({ questionTranslations: question });
  };

  handleQuestionTransaltionTextChange = (index: number, questionText: string) => {
    let questionTranslations = this.state.questionTranslations;
    let question = questionTranslations[index];
    question.text = questionText;

    this.setState({ questionTranslations }, () =>
      this.handleValue(nameof<ChangeFeedbackQuestionBankDto>('questionTranslations'), questionTranslations)
    );
  };

  handleQuestionTransaltionSubtitleChange = (index: number, questionSubtitle: string) => {
    let questionTranslations = this.state.questionTranslations;
    let question = questionTranslations[index];
    question.subtitle = questionSubtitle;

    this.setState({ questionTranslations }, () =>
      this.handleValue(nameof<ChangeFeedbackQuestionBankDto>('questionTranslations'), questionTranslations)
    );
  };

  handleQuestionTransaltionLanguageChange = (index: number, languageId: string) => {
    let questionTranslations = this.state.questionTranslations;
    let question = questionTranslations[index];
    question.languageId = languageId;
    this.setState({ questionTranslations }, () =>
      this.handleValue(nameof<ChangeFeedbackQuestionBankDto>('questionTranslations'), questionTranslations)
    );
  };

  removeDateRange = index => {
    let questionTranslations = this.state.questionTranslations;
    questionTranslations.splice(index, 1);

    this.setState({ questionTranslations }, () =>
      this.handleValue(nameof<ChangeFeedbackQuestionBankDto>('questionTranslations'), questionTranslations)
    );
  };

  showQuestionTranslationRows = () => {
    return this.state.questionTranslations.map((question, index) => {
      return (
        <React.Fragment key={`${question.languageId}_${index}`}>
          <Form.Group className="feedback-question-bank__selctor-textarea">
            <Form.Field
              inline
              width={12}
              className="feedback-question-bank__label-textarea"
              error={this.state.userClickedSave && (!question.text || question.text.length === 0)}
            >
              <label className="first-label hidden">&nbsp;</label>
              <TextArea
                value={question ? question.text : ''}
                onChange={(e, { value }) => this.handleQuestionTransaltionTextChange(index, value.toString())}
              />
            </Form.Field>

            <Form.Field
              error={this.state.userClickedSave && (!question.languageId || question.languageId.length === 0)}
              inline
              width={3}
              className="feedback-question-bank__translation-lng"
            >
              <LanguageEditor
                className={'planit-user-dropdown-custom'}
                nullable
                value={question.languageId}
                onChange={c => {
                  this.handleQuestionTransaltionLanguageChange(index, c == null ? null : c.id);
                }}
                onlyForTests={true}
              />
            </Form.Field>

            <Form.Field inline width={1} className="feedback-question-bank__translation-remove">
              <Icon className="clickable-icon remove-icon" color="red" name="remove" onClick={() => this.removeDateRange(index)} />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field inline width={12} className="feedback-question-bank__label-textarea">
              <label className="first-label hidden">&nbsp;</label>
              <Input
                value={question ? question.subtitle : ''}
                onChange={(e, { value }) => this.handleQuestionTransaltionSubtitleChange(index, value.toString())}
              />
            </Form.Field>
          </Form.Group>
        </React.Fragment>
      );
    });
  };

  public render() {
    const { t } = this.props as any;
    const answerTypeOptions = [
      { key: 1, text: t('Yes/No'), value: 'YesOrNo' },
      { key: 2, text: t('Text'), value: 'Text' },
      { key: 3, text: t('Rating'), value: 'Rating' }
    ];
    const mandatoryOptions = [
      { key: 1, text: t('Yes'), value: true },
      { key: 2, text: t('No'), value: false }
    ];

    const modalTitle = 'Edit Feedback Question';
    const showErrors =
      this.changeQuestionBankStore.state.result &&
      !this.changeQuestionBankStore.state.result.isSuccess &&
      (this.changeQuestionBankStore.state.result.messages || []).length !== 0;
    return (
      <Modal className="tna-question-bank__modal" open closeOnEscape={true} onClose={this.onCancelNewItem} closeOnDimmerClick={false}>
        <Dimmer active={this.changeQuestionBankStore.state.isBusy} style={{ background: 'rgba(0, 0, 0, 0.4)' }}>
          <Loader indeterminate>{t('')}</Loader>
        </Dimmer>
        <Modal.Header className="tna-squestion-bank__modal-header">{t(modalTitle)}</Modal.Header>
        <Modal.Content image>
          <Container>
            {showErrors && (
              <Message
                className="error-message__style"
                icon="exclamation circle"
                hidden={!showErrors}
                onDismiss={this.changeQuestionBankStore.clearMessages}
                error
                header={t('An error ocurred')}
                list={this.changeQuestionBankStore.state.result.messages.map(o => o.body)}
              />
            )}
            {this.changeQuestionBankStore.state.item && (
              <Form>
                <div className="feedback-question-bank__wrapper scroll">
                  <Form.Group className="feedback-question-bank__selctor-group">
                    <Form.Field
                      width={9}
                      inline
                      required
                      error={this.state.userClickedSave && this.changeQuestionBankStore.state.item.answerType == null}
                    >
                      <label className="first-label">{t('Answer Type')}</label>
                      <Dropdown
                        selection
                        inline
                        closeOnChange
                        closeOnEscape
                        closeOnBlur={true}
                        selectOnBlur={false}
                        selectOnNavigation={false}
                        multiple={false}
                        value={this.changeQuestionBankStore.state.item.answerType}
                        className="planit-user-dropdown"
                        options={answerTypeOptions}
                        error={this.state.userClickedSave && this.changeQuestionBankStore.state.item.answerType == null}
                        onChange={(e, { value }) => this.handleValue(nameof<ChangeFeedbackQuestionBankDto>('answerType'), value)}
                      />
                    </Form.Field>

                    <Form.Field
                      width={7}
                      inline
                      required
                      error={this.state.userClickedSave && this.changeQuestionBankStore.state.item.isMandatory == null}
                    >
                      <label>{t('Mandatory')}</label>
                      <Dropdown
                        error={this.state.userClickedSave && this.changeQuestionBankStore.state.item.isMandatory == null}
                        selection
                        inline
                        closeOnChange
                        closeOnEscape
                        closeOnBlur={true}
                        selectOnBlur={false}
                        selectOnNavigation={false}
                        multiple={false}
                        value={this.changeQuestionBankStore.state.item.isMandatory}
                        className="planit-user-dropdown"
                        options={mandatoryOptions}
                        onChange={(e, { value }) => this.handleValue(nameof<ChangeFeedbackQuestionBankDto>('isMandatory'), !!value)}
                      />
                    </Form.Field>
                  </Form.Group>

                  <Form.Group className="feedback-question-bank__selctor-textarea">
                    <Form.Field
                      required
                      inline
                      width={12}
                      className="feedback-question-bank__label-textarea"
                      error={this.state.userClickedSave && !this.changeQuestionBankStore.state.item.question}
                    >
                      <label className="first-label">{t('Question')}</label>
                      <TextArea
                        value={
                          this.changeQuestionBankStore.state.item.question ? this.changeQuestionBankStore.state.item.question.text : ''
                        }
                        onChange={(e, { value }) => this.onChangeQuestion(value.toString())}
                      />
                    </Form.Field>
                    <Button
                      className="custom-table-add-row-btn add-row-btn"
                      type="button"
                      content="Add Row"
                      onClick={this.addQuestionsTranslation}
                    >
                      {String(String(i18n.t('Add Translation')))}
                    </Button>
                  </Form.Group>
                  <Form.Group>
                    <Form.Field inline width={12} className="feedback-question-bank__label-textarea">
                      <label className="first-label">{t('Subtitle')}</label>
                      <Input
                        value={
                          this.changeQuestionBankStore.state.item.question ? this.changeQuestionBankStore.state.item.question.subtitle : ''
                        }
                        onChange={(e, { value }) => this.onChangeSubtitle(value.toString())}
                      />
                    </Form.Field>
                  </Form.Group>
                  {this.state.questionTranslations && this.state.questionTranslations.length > 0 && (
                    <>{this.showQuestionTranslationRows()}</>
                  )}
                </div>
              </Form>
            )}
          </Container>
        </Modal.Content>
        <Modal.Actions className="new-tna-question-bank__btns">
          <Button onClick={this.onCancelNewItem} basic>
            {t('Cancel')}
          </Button>
          <Button onClick={this.onChangeItem} positive>
            {t('Save')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(NewFeedbackQuestionBankModalView);
